import { IAction } from 'types/action';
import { initialState, IRedeemContent, IRedemptionStatus } from '../../modules/redemption/redemption.reducer';
import { REDEMPTION_STATUS } from '../../modules/redemption/redemption.constants';

import {
    ADDITIONAL_INFO,
    EMAIL_VERIFICATION,
    ERROR_MAINTENANCE,
    ERROR_MESSAGE,
    ERROR_MESSAGE_CODE_ALREADY_REDEEMED,
    ERROR_MESSAGE_GENERIC_ERROR,
    ERROR_MESSAGE_INVALID_CODE,
    ERROR_MESSAGE_NOT_ELIGIBLE,
    ERROR_MESSAGE_USER_ALREADY_REDEEMED,
    LANDING,
    PLATFORM_SELECTION,
    REDEEM_SUCCESS
} from '../../states/states.constants';
import { IRedeemCodeData } from 'types/redemption';
import { PLATFORM_TYPES } from '@sitegen/common/constants/platforms';
import { FIELD_VIEW_TYPES } from 'modules/additional-info-common/additional-info.constants';
import { IFieldRenderParams } from 'modules/additional-info-common/fields/fields.types';
import { SWITCH_PREVIEW_STATE_HOST } from '@sitegen/common/types/root-actions';

const redeemDataMock: IRedeemCodeData = {
    platform: PLATFORM_TYPES.PC,
    code: 'MOCK-MOCK-MOCK-MOCK',
    details: []
};

const additionalDetailsDefinitionMock: IFieldRenderParams[] = [
    {
        name: 'retailer',
        type: FIELD_VIEW_TYPES.STRING,
        isRequired: true,
        value: null
    },
    {
        name: 'mockNumber',
        type: FIELD_VIEW_TYPES.INT,
        isRequired: true,
        value: null
    },
    {
        name: 'product',
        type: FIELD_VIEW_TYPES.DROPDOWN,
        isRequired: true,
        value: ['T-800/101', 'T-900', 'T-1000 / T-1001', 'T-H / Hybrid human', 'I-950 / Enhanced human']
    },
    {
        name: 'purchaseDate',
        type: FIELD_VIEW_TYPES.DATE,
        isRequired: true,
        value: null
    }
];
const availablePlatformsMock: PLATFORM_TYPES[] = [
    PLATFORM_TYPES.PC,
    PLATFORM_TYPES.PS4,
    PLATFORM_TYPES.XONE,
    PLATFORM_TYPES.SWITCH,
    PLATFORM_TYPES.LUNA
];

export const redemptionReducer = (state = initialState, action: IAction): IRedemptionStatus => {
    switch (action.type) {
    case SWITCH_PREVIEW_STATE_HOST: {
        switch (action.payload) {
        case LANDING:
        case EMAIL_VERIFICATION:
            return initialState;
        case REDEEM_SUCCESS:
            return {
                ...initialState,
                status: REDEMPTION_STATUS.SUCCESS,
                unlockedContent: action.meta as IRedeemContent[]
            };
        case PLATFORM_SELECTION:
            return {
                ...initialState,
                status: REDEMPTION_STATUS.ADDITIONAL_INFO,
                redeemData: redeemDataMock,
                codeFirstPlatforms: availablePlatformsMock
            };
        case ADDITIONAL_INFO:
            return {
                ...initialState,
                redeemData: redeemDataMock,
                additionalDetailsDefinition: additionalDetailsDefinitionMock
            };
        case ERROR_MESSAGE:
        case ERROR_MESSAGE_GENERIC_ERROR:
            return {
                ...initialState,
                status: REDEMPTION_STATUS.GENERIC_ERROR
            };
        case ERROR_MESSAGE_NOT_ELIGIBLE:
            return {
                ...initialState,
                status: REDEMPTION_STATUS.NOT_ELIGIBLE
            };
        case ERROR_MESSAGE_CODE_ALREADY_REDEEMED:
            return {
                ...initialState,
                status: REDEMPTION_STATUS.CODE_ALREADY_REDEEMED
            };
        case ERROR_MESSAGE_USER_ALREADY_REDEEMED:
            return {
                ...initialState,
                status: REDEMPTION_STATUS.USER_ALREADY_REDEEMED
            };
        case ERROR_MESSAGE_INVALID_CODE:
            return {
                ...initialState,
                status: REDEMPTION_STATUS.INVALID_CODE
            };
        case ERROR_MAINTENANCE:
            return {
                ...initialState,
                status: REDEMPTION_STATUS.MAINTENANCE_ERROR
            };
        default:
            return state;
        }
    }
    default:
        return state;
    }
};

export default redemptionReducer;
